module.exports = __webpack_public_path__ + "static/media/new-label.5db1de8b.svg";